/**
 * Format a number as Canadian currency with comma separators.
 * Example: 10000 → "10,000.00"
 */
export function formatCurrency(value: number): string {
  return value.toLocaleString("en-CA", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
